<template>
  <button class="dropdown-item" :class="{ active: isActive }" @click="changeNetwork">
    {{ network.type | title }}
  </button>
</template>
<script>
export default {
  props: {
    network: { required: true, type: Object },
    active: { required: true, type: Object },
  },
  computed: {
    isActive() {
      return this.network.id === this.active.id;
    },
  },
  methods: {
    changeNetwork() {
      // if the agent is already in a network say of distributors
      // then  we don't want to change the network
      if (this.isActive) {
        return;
      }
      this.$emit("networkChanged", this.network);
    },
  },
};
</script>
